export const CommonModelFamiliesValues = ['q5new', 'a5new', 'q4etron', 'q6etron', 'q7'];
export const CommonModelFamiliesValuesUS = ['q5', 'a5', 'q4etron', 'q6etron', 'q7'];
